package es.subastia.domain.usecase

import es.subastia.domain.model.AuctionDomainModel
import es.subastia.domain.repository.AuctionsRepository
import kotlinx.coroutines.flow.Flow

class GetAuctionDetailUseCase(private val repository: AuctionsRepository) {
    operator fun invoke(auctionId: String): Flow<AuctionDomainModel?> {
        return repository.getAuctionById(auctionId)
    }
}
